import { Button, IButtonProps } from 'core-components/library/button'

export const SupportButton = (props: IButtonProps) => {
  return <Button {...props} color={'success'} />
}
